import ExportForm from "../common/ExportForm";
const EXPORT_COLUMNS = [
	{ key: "firstName", label: "First Name" },
	{ key: "middleName", label: "Middle Name" },
	{ key: "lastName", label: "Last Name" },
	{ key: "organizationName", label: "Organization Name" },
	{ key: "role", label: "Role" },
	{ key: "businessPhone", label: "Business Phone" },
	{ key: "extension", label: "Extension" },
	{ key: "fax", label: "Fax" },
	{ key: "mobile", label: "Mobile Number" },
	{ key: "email", label: "Email" },
	{ key: "street", label: "Street" },
	{ key: "city", label: "City" },
	{ key: "state", label: "State" },
	{ key: "zipCode", label: "Zip Code" },
	{ key: "overseaAddress", label: "Oversea Address" },

	{ key: "webiste", label: "Wesite" },
	{ key: "industry", label: "Industry" },
	{ key: "source", label: "Source" },
	{ key: "status", label: "Status" },
	{ key: "userResponsible1", label: "User Responsible 1" },
	{ key: "userResponsible2", label: "User Responsible 2" },
	{ key: "referredBy", label: "Referred By" },

	{ key: "background", label: "Background" },
	{ key: "void", label: "Void" }, 
	{ key: "voidReason", label: "Void Reason" }, 
	{ key: "validateReason", label: "Validate Reason" }, 
	{ key: "creatorId", label: "Creator" },
	{ key: "createdAt", label: "Created At" }, 
	{ key: "updaterId", label: "Updater" }, 
	{ key: "updatedAt", label: "Updated At" }, 
];
export default function LeadExportForm(){
	return <ExportForm columns = {EXPORT_COLUMNS}/>;
}